import React from 'react';

const PageTaxonomy = () => {
  return (
    <h1>Page taxonomy</h1>
  );
};

export default PageTaxonomy;
